import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useAssets from './useAssets';

const useSingleAsset = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading } = useAssets(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleAsset;
